import { render, staticRenderFns } from "./AddressBulkEditModal.vue?vue&type=template&id=f3885430&scoped=true&"
import script from "./AddressBulkEditModal.vue?vue&type=script&lang=js&"
export * from "./AddressBulkEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3885430",
  null
  
)

export default component.exports